import React from 'react';

const Footer = () => {
    return (
        <footer className="terminal-footer">
            <div style={{ marginTop: '40px' }} className="terminal-comment"># --- CONTACT ---</div>
            <div className="command-line">
                 <span className="prompt">kumara@portfolio:~$</span>
                 <span className="command">echo $CONTACT_INFO</span>
            </div>
            <div className="output">
                <div className="contact-info">
                    <div>
                        <span className="json-key">EMAIL=</span><a href="mailto:kumarayush2024@outlook.com">"kumarayush2024@outlook.com"</a>
                    </div>
                    <div>
                        <span className="json-key">LINKEDIN=</span><a href="https://linkedin.com/in/kumar-ayush-75248a205" target="_blank" rel="noopener noreferrer">"linkedin.com/in/kumar-ayush-75248a205"</a>
                    </div>
                    <div>
                        <span className="json-key">GITHUB=</span><a href="https://github.com/KumarAyush204" target="_blank" rel="noopener noreferrer">"github.com/KumarAyush204"</a>
                    </div>
                </div>
                <div className="copyright" style={{ marginTop: '20px', color: '#555' }}>
                    # &copy; {new Date().getFullYear()} Kumar Ayush. All Rights Reserved. Terminating session...
                </div>
            </div>
        </footer>
    );
};

export default Footer;
